export default __webpack_public_path__ + "static/media/line-chart.122ae5ef.png";